import { Typography } from 'components';
import { colors } from 'config';
import { getAppFlavor, getCurrentFont, isFitanu } from 'config/theme';
import img from 'images';

import { Grid, styled } from '@material-ui/core';

export const Wrapper = styled(Grid)(({ theme }) => ({
  backgroundColor: isFitanu()
    ? colors.landing.fitanuBlack
    : colors.landing.black,
  backgroundImage: !isFitanu()
    ? `url('${img.footerBackground[getAppFlavor()]}')`
    : "",
  backgroundSize: "cover",
  backgroundPosition: "center center",
  boxSizing: "border-box",
  position: "relative",
  ...(isFitanu()
    ? {
        "&::before": {
          content: '""',
          display: "block",
          position: "absolute",
          left: 0,
          top: 0,
          width: "100%",
          height: "100%",
          zIndex: 1,
          opacity: 0.1,
          backgroundImage: `url('${img.footerBackground[getAppFlavor()]}')`,
          backgroundPosition: "center center",
          backgroundSize: "cover",
        },
      }
    : {}),
  padding: theme.spacing(15, 19.5),
  [theme.breakpoints.down("lg")]: {
    padding: theme.spacing(12, 14),
  },
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(8, 10),
  },
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(7.5, 4.5),
  },
}));

export const Container = styled(Grid)(({ theme }) => ({
  boxSizing: "border-box",
  paddingRight: 0,
  textAlign: "center",
  zIndex: 2,
  "&:last-child": {
    paddingRight: 0,
    paddingLeft: 0,
    [theme.breakpoints.down("sm")]: {
      paddingLeft: 0,
      paddingRight: 0,
      marginTop: theme.spacing(4),
    },
  },
  [theme.breakpoints.down("sm")]: {
    paddingLeft: 0,
    paddingRight: 0,
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: 67,
  fontFamily: getCurrentFont("korolev, sans-serif"),
  lineHeight: "67px",
  color: theme.palette.common.white,
  letterSpacing: 0.8375,
  fontWeight: "bold",
  marginBottom: theme.spacing(6),
  [theme.breakpoints.down("sm")]: {
    fontSize: 37,
    letterSpacing: 0.4,
  },
}));

export const Subtitle = styled(Typography)(({ theme }) => ({
  fontSize: 18,
  color: theme.palette.common.white,
  lineHeight: "24px",
  letterSpacing: 0.06,
  "&:not(:last-child)": {
    marginBottom: theme.spacing(4),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: 15,
  },
}));
